module.exports = __webpack_public_path__ + "static/media/12.e3d64156.png";